import type { PLAAttributeDefinition, PLAElementRecord } from "./PLAState";
import { comparePLAElementsByDefaultOrder } from "./PLAElementSorting";

export type PLACubeViewSettings = {
   dimensionId?: string;
   memberId?: string;
   latest?: boolean;
   resetVersion?: number;
};

export function normalizePLACubeViewSettings(settings: PLACubeViewSettings, dimensionId: string | undefined, elements: PLAElementRecord[]): PLACubeViewSettings {
   return {
      ...settings,
      dimensionId: dimensionId || undefined,
      memberId: dimensionId && elements.some((element) => element.elementType === dimensionId && element.id === settings.memberId) ? settings.memberId : undefined,
      latest: Boolean(dimensionId && settings.latest)
   };
}

export function changePLACubeTimeDimension(settings: PLACubeViewSettings, dimensionId: string): PLACubeViewSettings {
   return { dimensionId, memberId: undefined, latest: false, resetVersion: (settings.resetVersion || 0) + 1 };
}

export function getPLACubePhaseElements(elements: PLAElementRecord[], dimensionId: string): PLAElementRecord[] {
   return elements.filter((element) => element.elementType === dimensionId).sort(comparePLAElementsByDefaultOrder);
}

export function getPLACubePhaseColor(index: number): string {
   return `hsl(${(index * 137.508) % 360}, 65%, 85%)`;
}

export function applyPLACubeGlobalFilter(definition: PLAAttributeDefinition, filter: Record<number, string> | undefined, settings: PLACubeViewSettings): Record<number, string> | undefined {
   const index = definition.cubeDimensions?.findIndex((dimension) => dimension.elementTypeId === settings.dimensionId) ?? -1;
   return index < 0 || !settings.memberId ? filter : { ...filter, [index]: settings.memberId };
}

export function findPLACubeLatestCell<T>(keys: string[], dimensionIndex: number, phases: PLAElementRecord[], memberId: string | undefined, getValue: (keys: string[]) => T): { value: T; phase: PLAElementRecord; color: string } | undefined {
   const cutoff = memberId ? phases.findIndex((phase) => phase.id === memberId) : phases.length - 1;
   for (let index = cutoff; index >= 0; index--) {
      const coordinates = keys.map((key, position) => position === dimensionIndex ? phases[index].id : key);
      const value = getValue(coordinates);
      if (value !== undefined && value !== null && value !== "") return { value, phase: phases[index], color: getPLACubePhaseColor(index) };
   }
   return undefined;
}
